function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter-1"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  type: "matrix",
  values: "0 0 0 0 0.768627 0 0 0 0 0.803922 0 0 0 0 0.839216 0 0 0 1.000000 0"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "CHANGES-APPLIED",
  transform: "translate(-239.000000, -471.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4",
  transform: "translate(80.000000, 411.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "flip-copy-3",
  transform: "translate(0.000000, 34.000000)",
  filter: "url(#filter-1)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(169.000000, 38.500000) rotate(270.000000) translate(-169.000000, -38.500000) translate(157.000000, 29.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.26637841,0.014626862 C8.83275077,-0.0574041025 8.41459158,0.142100516 8.24912616,0.492012914 L0.0674726996,17.9090704 C-0.0470704489,18.1529218 -0.014343835,18.4308032 0.15474367,18.6500876 C0.322936306,18.8685927 0.60656696,19 0.909288138,19 L9.0909416,19 C9.59274968,19 10,18.6461168 10,18.2083274 L10,0.791269843 C10,0.412856785 9.69276187,0.0874742516 9.26637841,0.014626862 Z",
  id: "Path",
  fill: "#000000",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.9325273,17.9090848 L15.7508738,0.49225661 C15.5863459,0.14234882 15.1672492,-0.0579695867 14.7336216,0.0148768438 C14.3072807,0.0877232743 14,0.413101523 14,0.791509598 L14,18.2083378 C14,18.6461215 14.4063555,19 14.9090584,19 L23.0907119,19 C23.393433,19 23.6770637,18.8685944 23.8452563,18.6500922 C24.0143438,18.4307736 24.0470704,18.1528958 23.9325273,17.9090848 Z",
  id: "Path",
  fill: "#000000",
  fillRule: "nonzero"
}))))));

var SvgHflip = function SvgHflip(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "25px",
    viewBox: "0 0 20 25",
    transform: "rotate(90) translate(-2)",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHflip, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hflip.e00843e6.svg";
export { ForwardRef as ReactComponent };